module.exports = __webpack_public_path__ + "static/lua_logo-e610772025cee16fb63e2df090ec8c30.svg";